import { createFileRoute, Outlet } from "@tanstack/react-router"
import { get } from "../../../../typed-client/get"

export const Route = createFileRoute("/app/art/productions/$id")({
  component: Outlet,
  beforeLoad: async (context) => {
    const production = await get("/api/Production/GetDetails", {
      productionId: parseInt(context.params.id),
    })

    return { getTitle: () => production?.title }
  },
})
